import { render, staticRenderFns } from "./SkinnyBanner.vue?vue&type=template&id=37dc1b86&"
import script from "./SkinnyBanner.vue?vue&type=script&lang=js&"
export * from "./SkinnyBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports